import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { GeneratedContentCreateInput, GeneratedContentCreatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GeneratedContentCreateInput;
type TData = GeneratedContentCreatePayload;

export const useContentGenerationCreate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation generatedContentCreate($input: GeneratedContentCreateInput!) {
      generatedContentCreate(input: $input) {
        success
        errors
        errorCode
        generatedContent {
          additionalInstructions
          contentFormat
          contentLength
          contentType
          createdAt
          generations {
            content
            id
            targetLanguage
          }
          id
          languages
          status
          styleGuide {
            culturalConsideration
            formality
            purposeOfText
            style
            targetAudience
            toneOfVoice
          }
          topic
          title
          words
        }
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
